import { Button } from '@design-system/components/button/button';
import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';

import * as styles from './ArchiveInDraftOfferModal.css';

type ArchiveInDraftOfferModalProps = {
  isOpen: boolean;
  programName: string;
  offerNames: Array<string>;
  isConfirming: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

export const ArchiveInDraftOfferModal = ({
  isOpen,
  programName,
  offerNames,
  isConfirming,
  onConfirm,
  onClose,
}: ArchiveInDraftOfferModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Archive and detach from draft offer"
      modalClassName={styles.modalWidth}
      centerContent={true}
    >
      <div
        className={styles.content}
        data-testid="archive-in-draft-offer-modal"
      >
        {programName ? (
          <Typography variant="body" size="large" fontWeight="bold">
            {programName}
          </Typography>
        ) : null}

        <Typography variant="body" size="large" fontWeight="normal">
          Based on available data, this program is attached to the following
          draft {offerNames.length === 1 ? 'offer' : 'offers'}:
        </Typography>

        <ul className={styles.offerList}>
          {offerNames.map((name) => (
            <li key={name}>
              <Typography variant="body" size="large" fontWeight="normal">
                {name}
              </Typography>
            </li>
          ))}
        </ul>

        <Typography variant="body" size="large" fontWeight="normal">
          Archiving the program will detach it from{' '}
          {offerNames.length === 1 ? 'that draft offer' : 'those draft offers'}.
          The {offerNames.length === 1 ? 'offer stays' : 'offers stay'} as draft
          without this program. No consumers are affected because the{' '}
          {offerNames.length === 1 ? 'offer was' : 'offers were'} never
          published.
        </Typography>

        <div className={styles.actions}>
          <Button variant="text" color="neutral" onClick={onClose}>
            Cancel
          </Button>
          <Button color="error" onClick={onConfirm} disabled={isConfirming}>
            Archive and detach
          </Button>
        </div>
      </div>
    </Modal>
  );
};
